import 'sanitize.css/sanitize.css';
import './index.css';

import App from './containers/app';
import { Provider } from 'react-redux';
import React from 'react';
import { render } from 'react-dom';
import store from './store';

const target = document.querySelector('#root')

render(
  <Provider store={store}>
    <App />
  </Provider>,
  target
)
